export default __webpack_public_path__ + "static/media/job_offer15_l.34edcd5e.jpg";